import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config/config.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { MessageResponse } from '../../models/message-response';
import { MessageResponseRequest } from '../../models/message-response-request';

@Injectable({
  providedIn: 'root',
})
export class MessageResponsesService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  messageResponsesEndpoint = `${this.config.patientApiUrl}/v1/PatientPortal/MessageResponses`;

  getMessageResponses(patientId: number, messageId: number): Observable<MessageResponse[]> {
    return this.utilityService.getRequest<MessageResponse[]>(
      `${this.messageResponsesEndpoint}?messageId=${messageId}&patientId=${patientId}&sortDirection=2`
    );
  }

  postMessageResponse(patientId: number, request: MessageResponseRequest): Observable<MessageResponse> {
    const url = this.messageResponsesEndpoint + '?patientId=' + patientId;
    return this.utilityService.postRequest<MessageResponse>(url, request);
  }
}
